import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  width: 100%;
  height: 408px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
